import React from 'react';
import BookSpotlight from './BookSpotlight';
import './LatestBookSection.css';

export default function LatestBookSection() {
  return (
    <div className='latestBookSection book-section'>
      <BookSpotlight variant='latest' />
    </div>
  );
}
